// constants/States.js

export const STATE_ABBREVIATIONS = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};

export const getStateName = (value) => {
  if (!value) return value;
  const upperValue = value.toUpperCase();
  if (STATE_ABBREVIATIONS[upperValue]) return STATE_ABBREVIATIONS[upperValue];

  const match = Object.values(STATE_ABBREVIATIONS).find(
    name => name.toLowerCase() === value.toLowerCase()
  );
  return match || value;
};

export const getStateAbbreviation = (value) => {
  if (!value) return value;
  const entry = Object.entries(STATE_ABBREVIATIONS).find(
    ([abbr, full]) =>
      full.toLowerCase() === value.toLowerCase() || abbr.toLowerCase() === value.toLowerCase()
  );
  return entry?.[0] || value;
};
